
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/members/resources/courses",
      function () {
        return require("private-next-pages/members/resources/courses/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/members/resources/courses"])
      });
    }
  